module.exports = __webpack_public_path__ + "static/media/logo-sgrz-white-v2.54527415.svg";